import React from 'react'

function PatientEditInfo() {
  return (
    <>
        <div className="d-flex justify-content-end">
            <button className="btn btn-light-success btn-sm">Save Changes</button>
        </div>
        <table className="table table-striped gy-3 gs-3 gx-3 mt-3">
            <tbody>
                <tr className=''>
                    <th className='fw-bolder fs-6 text-gray-800 ms-3'>Email</th>
                    <td>
                        <input type="text" className="form-control form-control-sm" />

                    </td>
                </tr>
                <tr>
                    <th className='fw-bolder fs-6 text-gray-800 ms-3'>Cell Phone Number</th>
                    <td>
                        <input type="text" className="form-control form-control-sm" />
                    </td>
                </tr>
                <tr>
                    <th className='fw-bolder fs-6 text-gray-800 ms-3'>Home Phone Number </th>
                    <td>
                        <input type="text" className="form-control form-control-sm" />

                    </td>
                </tr>
            </tbody>
        </table>
    </>
  )
}

export default PatientEditInfo